import React from 'react';
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery';

export const EmptyLabel: React.FC = () => {
  const showLabel = useMediaQuery('(min-width: 768px)');

  return <>{showLabel && <label className="d-block">&nbsp;</label>}</>;
};
